import React from 'react';
import PropTypes from 'prop-types';
import { Icon, PageTitle } from '@fasstech/middle-design-system';

export const SummaryHeader = ({ getMiddleText }) => {
  return (
    <div className={'flex flex-col items-center mb-6'}>
      <Icon name={'bag'} />
      <PageTitle>{getMiddleText('RECAPITULATIF_VIEW_TITLE')}</PageTitle>
    </div>
  );
};

SummaryHeader.propTypes = {
  getMiddleText: PropTypes.func.isRequired
};
